<template>
  <component
    :is="pillTag"
    v-bind="pillAttrs"
    class="tag-pill"
    :class="`tag-pill-${category}`"
  >
    <span class="tag-pill-dot" aria-hidden="true"></span>
    <span>{{ label }}</span>
  </component>
</template>

<script>
export default {
  name: 'TagPill',
  props: {
    label: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      default: 'experience',
    },
    to: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    pillTag() {
      return this.to ? 'router-link' : 'span';
    },
    pillAttrs() {
      return this.to ? { to: this.to } : {};
    },
  },
};
</script>

<style scoped>
.tag-pill {
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  color: #fff !important;
  display: inline-flex;
  font-family: "Oswald", serif;
  font-size: 0.82rem;
  font-weight: 800;
  gap: 7px;
  letter-spacing: 0;
  line-height: 1.2;
  padding: 6px 10px;
  text-decoration: none;
  text-transform: uppercase;
  transition: border-color 160ms ease, transform 160ms ease;
}

.tag-pill:hover,
.tag-pill:focus {
  border-color: #e23232;
  transform: translateY(-1px);
}

.tag-pill-dot {
  border-radius: 999px;
  display: inline-block;
  height: 7px;
  width: 7px;
}

.tag-pill-experience .tag-pill-dot {
  background: #e23232;
}

.tag-pill-destination .tag-pill-dot {
  background: #39a8ff;
}

.tag-pill-theme .tag-pill-dot {
  background: #f0b13c;
}

.tag-pill-collection .tag-pill-dot {
  background: #7ddc87;
}
</style>
